import React, { FC, ReactNode, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import Header from '@components/Header';
import Sidebar from '@components/Sidebar';
import { SidebarContextProvider } from '@src/context/SidebarContext';

import GlobalNotification from './hoc/GlobalNotification';
import { TermsUpdateNotificationProvider } from './hoc/GlobalNotification/TermsUpdateNotification/context';

type Props = {
  children: ReactNode;
};

export const PrivateLayout: FC<Props> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return isAuthenticated ? (
    <TermsUpdateNotificationProvider>
      <GlobalNotification>
        <SidebarContextProvider>
          <div className="flex w-full min-h-screen">
            <div className="w-full" data-testid="header-div">
              <Header openSidebar={openSidebar} />
              <div
                className="min-h-screen pt-[67px] sm:pt-[77px]"
                data-testid="children-div"
              >
                {children}
              </div>
            </div>
            <div className="min-h-screen" data-testid="sidebar-div">
              <Sidebar
                closeSidebar={closeSidebar}
                isSidebarOpen={isSidebarOpen}
              />
            </div>
          </div>
        </SidebarContextProvider>
      </GlobalNotification>
    </TermsUpdateNotificationProvider>
  ) : null;
};
